import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Hidden,
  IconButton,
  List,
  ListItem,
  ListItemIcon,
  ListItemSecondaryAction,
  ListItemText,
  makeStyles,
  Typography,
} from "@material-ui/core";
import { Close, GetApp, InsertDriveFile } from "@material-ui/icons";
import { Skeleton } from "@material-ui/lab";
import React, { useState } from "react";
import { getMatchSummaryForRegistration } from "../../Base/Services/MatchService";
import { displayName, displayAddress } from "../../Admin/helper/DisplayUtil";
import { downloadRegistrationDocument } from "../../Base/Services/RegistrationDocumentService";
import { RegistrationType } from "../../Base/AdoptionConstants";

const useStyles = makeStyles(() => ({
  contactInfo: {
    paddingLeft: 50,
  },
  documents: {
    paddingTop: 20,
    paddingLeft: 0,
  },
}));

export default function CertificateInformationDialog({ open, onClose, registrationId, ariaLabel, ...props }) {
  const [isLoading, setIsLoading] = useState(true);
  const [documents, setDocuments] = useState(null);
  const classes = useStyles();

  React.useEffect(() => {
    if (open) {
      setIsLoading(true);
      getMatchSummaryForRegistration(registrationId)
        .then(setDocuments)
        .finally(() => setIsLoading(false));
    } else {
      setDocuments(null);
    }
  }, [registrationId, open]);

  return (
    <Dialog
      open={open}
      onClose={() => {
        onClose();
      }}
      fullWidth={true}
      maxWidth="sm"
      aria-label={ariaLabel}
      {...props}
    >
      <DialogTitle>
        <span style={{ display: "flex", justifyContent: "space-between" }}>
          <span>Birth Certificate</span>
          <IconButton size="small" color="default" onClick={onClose}>
            <Close />
          </IconButton>
        </span>
      </DialogTitle>
      <DialogContent>
        {documents && !isLoading && (
          <div>
            {Boolean(documents.stateDocuments?.length) && (
              <>
                <Typography vairaint="body1" paragraph className={classes.documents}>
                  Documents from Office of Vital Records and Statistics:
                </Typography>
                <List>
                  {documents?.stateDocuments?.map((r, i) => (
                    <ListItem hidden key={i} button onClick={() => downloadRegistrationDocument(r)}>
                      <Hidden xsDown>
                        <ListItemIcon>
                          <InsertDriveFile />
                        </ListItemIcon>
                      </Hidden>
                      <ListItemText
                        primary={
                          <span
                            style={{
                              textOverflow: "ellipsis",
                              maxWidth: "calc(100% - 80px)",
                              overflow: "hidden",
                              whiteSpace: "nowrap",
                              display: "block",
                            }}
                          >
                            {r.documentName}
                          </span>
                        }
                      ></ListItemText>
                      <ListItemSecondaryAction>
                        <IconButton onClick={() => downloadRegistrationDocument(r)}>
                          <GetApp />
                        </IconButton>
                      </ListItemSecondaryAction>
                    </ListItem>
                  ))}
                </List>
              </>
            )}
          </div>
        )}
        {isLoading && (
          <>
            <Skeleton variant="text" />
            <Skeleton variant="rect" style={{ marginTop: 12, height: 60 }} />
          </>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
}
